/** 服务类型 */
export type ServiceType = 'seaart' | 'publish'

/** 线路配置 */
interface ServiceLineConfig {
  /** 网关地址 */
  gateway: string
  /** 备用线路 */
  backupLines: string[]
}

/** 按服务类型组织的网关与备用线路配置 */
const serviceLineConfigs: Record<ServiceType, ServiceLineConfig> = {
  seaart: {
    gateway: __sharedEnv__.seaartGateway,
    backupLines: __sharedEnv__.seaartGatewayBackups,
  },
  publish: {
    gateway: __sharedEnv__.publishGateway,
    backupLines: __sharedEnv__.publishGatewayBackups,
  },
}

/** 开发环境通过 localStorage 覆盖备用线路，便于调试 */
if (
  import.meta.env.MODE === 'develop' ||
  import.meta.env.MODE === 'release' ||
  import.meta.env.MODE === 'cn-develop' ||
  import.meta.env.MODE === 'cn-release' ||
  import.meta.env.DEV
) {
  const seaartGatewayLines = localStorage.getItem('__seaart_lines')
  const publishGatewayLines = localStorage.getItem('__publish_lines')

  try {
    if (seaartGatewayLines) {
      console.log('seaartGatewayLines :>> ', seaartGatewayLines)
      serviceLineConfigs.seaart.backupLines = JSON.parse(seaartGatewayLines)
    }
    if (publishGatewayLines) {
      console.log('publishGatewayLines :>> ', publishGatewayLines)
      serviceLineConfigs.publish.backupLines = JSON.parse(publishGatewayLines)
    }
  } catch (error) {
    console.error('error :>> ', error)
  }
}

/** 获取指定服务类型的网关与备用线路配置 */
export function getServiceLineConfig(serviceType: ServiceType): ServiceLineConfig {
  return serviceLineConfigs[serviceType]
}
